<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="min-height: 80vh;height: auto" @click.stop>
                <div class="dialog-title" v-t="'message.title_edit_stt_dictionary_setting'"></div>
                <hr class="dialog-hr">
                <div class="dialog-body-setting">
                    <!-- 辞書名 -->
                    <div class="body-dictname">
                        <el-form label-width="180px">
                            <el-form-item prop="dictionaryName" ref="dictionaryName" style="margin-bottom:30px;">
                                <div slot="label" style="text-align:left" v-t="'message.item_stt_extension_dictionary_display_name'"></div>
                                <el-input id="dictionaryName" v-model="dictionaryName.value" type="text" style="width:300px"
                                        @compositionstart.native="compositionDictNameStart()" @compositionend.native="compositionDictNameEnd()"
                                        @input.native="inputDictNameCheck()"/>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!-- 言語 -->
                    <div class="body-lang">
                        <div class="object-titlebox header-line">
                            <td class="object-titlebox-text" v-t="'message.item_stt_extension_dictionary_phrase_language'"></td>
                        </div>
                        <div style="padding:7px 12px;">
                            <!-- NOTE: Make enable el-select when multilingual supported. -->
                            <el-select v-model="selectedLanguageIndex" disabled style="width:130px;padding-right:15px" @change="handleChangeLanguage()">
                                <div v-if="$i18n.locale === 'ja'">
                                    <el-option style="font-size:12px" v-for="language in languageList" :key="language.value" :label="language.description" :value="language.value"></el-option>
                                </div>
                                <div v-else>
                                    <el-option style="font-size:12px" v-for="language in languageList" :key="language.value" :label="language.description_en" :value="language.value"></el-option>
                                </div>
                            </el-select>
                        </div>
                    </div>
                    <!-- 単語 -->
                    <div class="body-phrase">
                        <!--- 単語登録（ヘッダ） --->
                        <div class="object-titlebox header-line">
                            <td class="object-titlebox-text phrase-column0" v-t="'message.item_stt_extension_dictionary_phrase_spoken'" style="cursor:pointer" v-on:click="sortPhraseList('spoken')" v-on:mouseenter="onEnterHeader" v-on:mouseleave="onLeaveHeader"></td>
                            <td class="object-titlebox-text phrase-column1" v-t="'message.item_stt_extension_dictionary_phrase_text'" style="cursor:pointer" v-on:click="sortPhraseList('text')" v-on:mouseenter="onEnterHeader" v-on:mouseleave="onLeaveHeader"></td>
                            <td class="object-titlebox-text phrase-column2" v-t="'message.item_stt_extension_dictionary_phrase_category'" style="cursor:pointer" v-on:click="sortPhraseList('category')" v-on:mouseenter="onEnterHeader" v-on:mouseleave="onLeaveHeader"></td>
                            <td class="object-titlebox-text phrase-column3"></td>
                            <td class="gutter"></td>
                        </div>
                        <el-form><!--- label-width="250px"--->
                            <div id="phrase-list" class="inner-scrollable">
                            <table v-if="showPhrase" width="100%">
                                <!--- 単語登録（明細） --->
                                <tr v-for="(phrase, index) in actualPhraseList" class="phrase-record" :key="index">
                                    <td class="phrase-column0">
                                        <el-form-item class="setting-items" :prop="'phrase'+index+'-spoken'" :ref="'phrase'+index+'-spoken'">
                                            <el-input :id="'phrase'+index+'-spoken'" type="text" v-model="phrase.spoken"
                                                    @compositionstart.native="compositionPhraseStart($event.target.id)" @compositionend.native="compositionPhraseEnd($event.target.id)"
                                                    @input.native="inputPhraseCheck($event.target.id)"/>
                                        </el-form-item>
                                        <div v-if="phrase.hasErrors()" class="phrase-column-error-bottom"></div>
                                    </td>
                                    <td class="phrase-column1 ">
                                        <el-form-item class="setting-items" :prop="'phrase'+index+'-text'" :ref="'phrase'+index+'-text'">
                                            <el-input :id="'phrase'+index+'-text'" type="text" v-model="phrase.text"
                                                    @compositionstart.native="compositionPhraseStart($event.target.id)" @compositionend.native="compositionPhraseEnd($event.target.id)"
                                                    @input.native="inputPhraseCheck($event.target.id)"/>
                                        </el-form-item>
                                        <div v-if="phrase.hasErrors()" class="phrase-column-error-bottom"></div>
                                    </td>
                                    <td class="phrase-column2">
                                        <el-form-item class="setting-items" :prop="'phrase'+index+'-category'" :ref="'phrase'+index+'-category'">
                                            <el-select :id="'phrase'+index+'-category'" v-model="phrase.category" placeholder="">
                                                <div v-if="$i18n.locale === 'ja'">
                                                    <el-option v-for="category in categoryList" :key="category.key" :label="category.value_jp" :value="category.key"></el-option>
                                                </div>
                                                <div v-else>
                                                    <el-option v-for="category in categoryList" :key="category.key" :label="category.value_en" :value="category.key"></el-option>
                                                </div>
                                            </el-select>
                                        </el-form-item>
                                        <div v-if="phrase.hasErrors()" class="phrase-column-error-bottom"></div>
                                    </td>
                                    <td class="phrase-column3 column-button">
                                        <button class="transparent-button" type="button" v-on:click="handleDeletePhrase(index)"><img src="@/assets/delete.svg" alt=""/></button>
                                        <div v-if="phrase.hasErrors()" class="phrase-column-error-bottom"></div>
                                    </td>
                                </tr>
                                <!--- 単語登録（追加） --->
                                <tr class="phrase-record" v-if="showAddPhrase">
                                    <td class="phrase-column0">
                                        <el-form-item class="setting-items" prop="phraseA-spoken" ref="phraseA-spoken">
                                            <el-input id="phraseA-spoken" type="text" v-model="addPhrase.spoken"
                                                    @compositionstart.native="compositionPhraseStart($event.target.id)" @compositionend.native="compositionPhraseEnd($event.target.id)"
                                                    @input.native="inputPhraseCheck($event.target.id)"/>
                                        </el-form-item>
                                    </td>
                                    <td class="phrase-column1">
                                        <el-form-item class="setting-items" prop="phraseA-text" ref="phraseA-text">
                                            <el-input id="phraseA-text" type="text" v-model="addPhrase.text" :placeholder="$t('message.place_holder_input_text')"
                                                    @compositionstart.native="compositionPhraseStart($event.target.id)" @compositionend.native="compositionPhraseEnd($event.target.id)"
                                                    @input.native="inputPhraseCheck($event.target.id)"/>
                                        </el-form-item>
                                    </td>
                                    <td class="phrase-column2">
                                        <el-form-item class="setting-items" prop="phraseA-category" ref="phraseA-category">
                                            <el-select id="phraseA-category" v-model="addPhrase.category" placeholder="">
                                                <div v-if="$i18n.locale === 'ja'">
                                                    <el-option v-for="category in categoryList" :key="category.key" :label="category.value_jp" :value="category.key"></el-option>
                                                </div>
                                                <div v-else>
                                                    <el-option v-for="category in categoryList" :key="category.key" :label="category.value_en" :value="category.key"></el-option>
                                                </div>
                                            </el-select>
                                        </el-form-item>
                                    </td>
                                    <td class="phrase-column3 column-button">
                                        <el-button class="enable-command-button" :disabled="addPhrase.disableAdd()" v-t="'message.common_action_add'" v-on:click="handleAddPhrase()" ></el-button>
                                    </td>
                                </tr>
                            </table>
                            </div>
                        </el-form>
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableSave" @click="saveEdit" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import commonValidate from '@/components/common-validate.js';

const TYPE_TRY_ADD = 2;
const TYPE_ADD = 1;
const TYPE_ORIGINAL = 0;
const TYPE_DELETE = -1;

export default {
    props: {
        baseDictionaryInfo : {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            languageList: [],
            selectedLanguageIndex: 0,
            languageIndex: 0,
            showPhrase: true,
            categoryList: [],
            dictionaryName: {validationRule: "reqDisplayName", value: "", isComposing: false, error: false},
            originalPhraseList: {},
            phraseList: [],
            phraseValidationRule: {spoken: "sttPhraseField", text: "reqSttPhraseField", category: "none"},
            maxPhraseCountPerLang: 0,
            addPhrase: null,
            showAddPhrase: false,
            actionAdd: false,
            actionSave: false,
            sortColumn: {value: "", order: 0},
        }
    },

    computed: {
        actualPhraseList: function() {
            return this.phraseList.filter(p => p.type === TYPE_ADD || p.type === TYPE_ORIGINAL);
        },
        existPhraseErrors: function() {
            return this.actualPhraseList.some(p => p.hasErrors());
        },
        existDictNameError: function() {
            return this.dictionaryName.error;
        },
        disableSave: function() {
            return this.existPhraseErrors || this.existDictNameError || this.actionSave;
        },
    },

    created: function() {
        this.dictionaryName.value = this.baseDictionaryInfo.name;
        this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale);
        this.categoryList = commonUtil.getSttExtensionPhraseCategoryList();
        this.setLanguageIndex();
        this.getPhrases();
        this.initializeAddPhrase();
    },

    updated: function() {
        if (this.actionAdd) {
            let obj = document.getElementById("phrase-list");
            obj.scrollTop += obj.scrollHeight;
            this.actionAdd = false;
        }
    },

    methods: {
        setLanguageIndex() {
            // NOTE: Switch code when multilingual supported.

            this.languageIndex = this.selectedLanguageIndex = 1;

            // let countryCode = this.$root.store.countryCode.alpha3
            // let language = commonUtil.getLanguageIndexList(this.$i18n.locale).find(item => item.countryCode.indexOf(countryCode) >= 0)
            // if (language) {
            //     this.languageIndex = this.selectedLanguageIndex = language.value;
            // } else {
            //     this.languageIndex = this.selectedLanguageIndex = 2;
            // }
        },
        getPhrases() {
            this.showAddPhrase = false;
            this.phraseList = []; // clear local data in all cases.
            this.$nextTick(this.fetchPhrases);
        },

        fetchPhrases() {
            let loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });

            let self = this;
            server.post('/getsttphrase', {dictionaryId: this.baseDictionaryInfo.id, languageIndex: this.languageIndex})
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                            let phraseList = [];
                            for (let phrase of res.data.phrases) {
                                phraseList.push({
                                    id:            phrase.id,
                                    spoken:        phrase.spoken,
                                    text:          phrase.text,
                                    category:      phrase.category,
                                    type:          TYPE_ORIGINAL,
                                    isComposing:   {spoken: false, text: false, category: false},
                                    errors:        {spoken: false, text: false, category: false},
                                    hasErrors: function() {
                                        return this.errors.spoken || this.errors.text || this.errors.category;
                                    },
                                });
                                self.$set(self.originalPhraseList, phrase.id, phrase);
                            }
                            self.phraseList = phraseList;
                            self.showAddPhrase = true;
                            self.maxPhraseCountPerLang = res.data.maxPhraseCountPerLang;
                            break;
                        case constants.STATUS_ERROR_OBJECT_NOT_FOUND:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_stt_extension_dictionary_already_changed"));
                            return;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getPhrases").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self, "getPhrases", error);
                })
                .finally(() => {
                    loadingScreen.close();
                });
        },
        sortPhraseList(column) {
            if (this.sortColumn.value === column) {
                this.sortColumn.order *= (-1);
            } else {
                this.sortColumn.value = column;
                this.sortColumn.order = 1;
            }
            this.phraseList.sort((p1, p2) => {
                if (p1[column] < p2[column]) {
                    return -1 * this.sortColumn.order;
                }
                if (p1[column] > p2[column]) {
                    return 1 * this.sortColumn.order;
                }
                return 0;
            });
        },
        onEnterHeader(e) {
            e.target.style.fontWeight = "bold";
        },
        onLeaveHeader(e) {
            e.target.style.fontWeight = "normal";
        },
        inputDictNameCheck() {
            if (this.dictionaryName.isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.dictionaryName.validationRule, this.dictionaryName.value);
            if (validateResult.valid) {
                if (this.baseDictionaryInfo.name !== this.dictionaryName.value) {
                    this.$emit('validateDictNameDuplicated', this.dictionaryName.value, this.updateNameState)
                }
            } else {
                this.updateNameState(false, validateResult.message)
            }
        },
        updateNameState(valid, message) {
            if (valid) {
                this.dictionaryName.error = false;
                this.$refs.dictionaryName.clearValidate();
            } else {
                this.dictionaryName.error = true;
                this.$refs.dictionaryName.validateState = "error";
                this.$refs.dictionaryName.validateMessage = message;
            }
        },
        compositionDictNameStart() {
            this.dictionaryName.isComposing = true;
        },
        compositionDictNameEnd() {
            this.dictionaryName.isComposing = false;
            this.inputDictNameCheck()
        },
        inputPhraseCheck(eventTargetId) {
            let {phrase: currentPhrase, column} = this.getTargetPhraseAndColumnById(eventTargetId);
            if (currentPhrase.isComposing[column]){
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.phraseValidationRule[column], currentPhrase[column], this.languageIndex);
            let ref = currentPhrase.type === TYPE_TRY_ADD ? this.$refs[eventTargetId] : this.$refs[eventTargetId][0];
            if (validateResult.valid) {
                currentPhrase.errors[column] = false;
                ref.clearValidate();
            } else {
                currentPhrase.errors[column] = true;
                ref.validateState = "error";
                ref.validateMessage = validateResult.message;
            }
        },
        compositionPhraseStart(eventTargetId) {
            let {phrase, column} = this.getTargetPhraseAndColumnById(eventTargetId);
            phrase.isComposing[column] = true;
        },
        compositionPhraseEnd(eventTargetId) {
            let {phrase, column} = this.getTargetPhraseAndColumnById(eventTargetId);
            phrase.isComposing[column] = false;
            this.inputPhraseCheck(eventTargetId);
        },
        getTargetPhraseAndColumnById(eventTargetId) {
            let indexStr = eventTargetId.substring("phrase".length).split("-");
            let phrase = indexStr[0] === "A"
                ? this.addPhrase
                : this.actualPhraseList[Number(indexStr[0])];
            return {phrase: phrase, column: indexStr[1]};
        },
        handleChangeLanguage() {
            if (this.phraseList.some(this.phraseModified)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_notify_stt_extension_dictionary_phrase_cannot_change_language"));
                this.selectedLanguageIndex = this.languageIndex;
                return;
            }
            this.languageIndex = this.selectedLanguageIndex;
            this.getPhrases();
            this.initializeAddPhrase();
            this.reDraw();
        },
        handleAddPhrase() {
            this.actionAdd = true;
            if (this.actualPhraseList.length >= this.maxPhraseCountPerLang) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_stt_extension_dictionary_phrase_exceeds_max_count").replace("{maxPhraseCountPerLang}", this.maxPhraseCountPerLang));
                return;
            }
            this.addPhrase.type = TYPE_ADD;
            if (this.phraseList.indexOf(this.addPhrase) < 0) {
                this.phraseList.push(this.addPhrase);
            }
            this.initializeAddPhrase();
        },
        handleDeletePhrase(index) {
            let currentPhrase = this.actualPhraseList[index];
            if (currentPhrase.type === TYPE_ORIGINAL) {
                currentPhrase.type = TYPE_DELETE;
            } else if (currentPhrase.type === TYPE_ADD) {
                let index = this.phraseList.indexOf(currentPhrase);
                this.phraseList.splice(index, 1);
            }
        },
        initializeAddPhrase() {
            this.addPhrase = {
                spoken:        "",
                text:          "",
                category:      this.categoryList[0].key,
                type:          TYPE_TRY_ADD,
                isComposing:   {spoken: false, text: false, category: false},
                errors:        {spoken: false, text: false, category: false},
                hasErrors: function() {
                    return this.errors.spoken || this.errors.text || this.errors.category;
                },
                disableAdd: function() {
                    return this.text === "" || this.hasErrors();
                }
            }
        },
        phraseModified(phrase, index, array) {
            return phrase.type !== TYPE_ORIGINAL || !this.samePhrase(phrase, this.originalPhraseList[phrase.id]);
        },
        samePhrase(p1, p2) {
            return p1.spoken === p2.spoken && p1.text === p2.text && p1.category === p2.category;
        },
        reDraw() {
            this.showPhrase = false;
            this.$nextTick(() => {
                this.showPhrase = true;
            })
        },
        saveEdit() {
            this.actionSave = true;
            let self = this;
            let duplicated = this.actualPhraseList.some(function(phrase, index, array) {
                for (let j = 0; j < index; j++) {
                    if (self.samePhrase(phrase, array[j])) {
                        return true;
                    }
                }
                return false;
            });
            if (duplicated) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_stt_extension_dictionary_phrase_duplicate"));
                this.actionSave = false;
                return;
            }

            let dictParams = {
                id: this.baseDictionaryInfo.id,
                name: this.dictionaryName.value,
            };

            let requestPhraseList = this.phraseList
                .filter(this.phraseModified)
                .map(p =>
                    p.type === TYPE_ADD      ? {type: p.type, phrase: {spoken: p.spoken, text: p.text, category: p.category}} :
                    p.type === TYPE_ORIGINAL ? {type: p.type, phrase: {id: p.id, spoken: p.spoken, text: p.text, category: p.category}} :
                    p.type === TYPE_DELETE   ? {type: p.type, phrase: {id: p.id}}  : {}
                );
            let phraseParams = {
                dictionaryId: this.baseDictionaryInfo.id,
                languageIndex: this.languageIndex,
                inputList: requestPhraseList,
            };

            this.$emit('save', dictParams, phraseParams);
        },
    }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialog-body-setting {
    height: calc(85vh - 180px);
    font-size: 14px;
    overflow: auto;
    padding: 20px;
}
.body-dictname {
    padding-left: 20px;
    font-size: 14px;
}
.body-lang {
    display: inline-block;
    width: 20%;
}
.body-phrase {
    width: 80%;
    float: right;
}
.header-line {
    margin-bottom: 10px;
}
div.header-line > td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
}
.inner-scrollable {
    overflow-x: hidden;
    overflow-y: scroll;
    height:calc(85vh - 295px);
}
.phrase-record {
}
tr.phrase-record > td {
    padding: 7px 12px;
}
.phrase-column0 {
    width: 27.5%;
}
.phrase-column1 {
    width: 27.5%;
}
.phrase-column2 {
    width: 15%;
}
.phrase-column3 {
    width: 10%;
}
.gutter {
    width: 2.2% !important;
}
.phrase-column-error-bottom {
    padding-bottom: 20px;
}
.setting-items {
    margin-bottom: 0;
}
.column-button {
    text-align: center;
}
</style>
